const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const prototype = require('./prototype');
const baseConfig = require('./config');

/**
 * Input component
 * @param {string} selector selector for the component in the client side.
 * @returns {object} Instance containing the input
 */
module.exports = function InputClient(selector = '[data-component="Input"]', configuration = {}) {
    if (elementExist(selector)) {
        // Build instance based on custom input object so we inherit the proto methods
        const instance = Object.create(prototype);

        // Config
        instance.config = { ...baseConfig, ...configuration };

        // Element reference
        instance.element = document.querySelector(selector);

        // Id reference
        instance.id = randomId(randomId('input'));

        // Init error handler
        instance.error = false;

        // Value reference
        instance.value = instance.get();

        // Auto init
        if (instance.config.init) instance.init();

        return instance;
    }
};
